/**
 * Which `device_credential_states` values mean "the credential may still be sitting on that
 * reader right now".
 *
 * Shared by the UI that REPORTS stranded credentials (Dispositivos de Acesso) and the code
 * that REMOVES them (deviceRevoke), because the two disagreeing is how a credential outlives
 * the access that justified it: the panel would stop listing a device the person lost access
 * to, and the revoke would never try it.
 *
 * `confirmed_absent` and `unknown` are deliberately out — there is nothing to clean up.
 */
export const CREDENTIAL_MAY_BE_PRESENT = new Set([
  'confirmed_present',
  'grant_pending',
  'grant_failed',
  'revoke_pending',
  'revoke_failed',
  'needs_reconciliation',
]);

export function mayStillHoldCredential(state?: string | null): boolean {
  return CREDENTIAL_MAY_BE_PRESENT.has(state ?? '');
}
